import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import Nav from './Nav';

class SideBar extends Component {

  state = {};

  render() {
    let {
      location,
    } = this.props;

    return (
      <div className="sidebar" >
          <div className="brand">
              <span className="logoImage"><i className="fa fa-book" style={{'font-size':'25px'}}></i> Swera Techno</span>
          </div>

        <div className="sidebar-wrapper">
          <Nav />
        </div>
        <div
          className="sidebar-background">
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
});

export default withRouter(
  connect(mapStateToProps)(SideBar)
);


// WEBPACK FOOTER //
// ./src/components/SideBar/index.js